import { useLeaderboard } from '../hooks/useLeaderboard'
import { LeaderboardTable } from '../components/leaderboard/LeaderboardTable'

export function LeaderboardPage() {
  const { users, loading, error } = useLeaderboard()

  if (error) {
    return (
      <div className="text-center text-red-600">
        Une erreur est survenue lors du chargement du classement
      </div>
    )
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">Classement</h1>
      <LeaderboardTable users={users} loading={loading} />
    </div>
  )
}